import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { logout, AppDispatch } from "../../redux/internal";

export const Logout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const timeUntilRedirectToLogin = Number(process.env.REACT_APP_TIME_REDIRECT_AFTER_LOGOUT);

  useEffect(() => {
    void dispatch(logout());

    const interval = setInterval(() => {
      navigate("/signin", { replace: true });
    }, timeUntilRedirectToLogin);

    return () => clearInterval(interval);
  }, [dispatch, navigate, timeUntilRedirectToLogin]);

  return <span style={{ fontSize: 24 }}>{t('youHaveBeenLoggedOut')}</span>;
};
